





















import {Component, Prop, Vue} from 'vue-property-decorator';
import {ActiveInject} from "@/support/reactive"

/**
 * @status stable
 * @published $next
 * @changelog $next Published.
 *  Add width and color options
 *  Add allow empty option
 */
@Component
export default class JdsRichRadioOption extends Vue {
    @Prop() value!: string | boolean
    @Prop() icon!: string
    @Prop({ default: false, type: Boolean }) disabled!: boolean
    @ActiveInject({from: 'jds.rich-radio.mode', default: 'simple'}) mode!: 'simple'|'list'|'grid-auto'|'grid-columns'
    @ActiveInject({from: 'jds.rich-radio.color', default: 'green'}) colors!: 'green'|'purple'
    @ActiveInject({from: 'jds.rich-radio.bus'}) bus!: Vue
    @ActiveInject({from: 'jds.rich-radio.value'}) currentValue!: string

    get isActive() {
        return this.value === this.currentValue
    }

    get mainClasses() {
        return {
            'jdsc-rich-radio-option--standard': this.mode === 'simple',
            'jdsc-rich-radio-option--card':  this.mode !== 'simple',
            'jdsc-rich-radio-option--grid':  ['grid-auto', 'grid-columns'].includes(this.mode),
            'jdsc-rich-radio-option--active': this.isActive,
            'jdsc-rich-radio-option--disabled': this.disabled,
        }
    }

    get colorClass() {
        return {
            'green': this.colors === 'green',
            'purple': this.colors === 'purple'
        }
    }

    get showIcon() {
        return ['grid-auto', 'grid-columns'].includes(this.mode) && this.icon
    }

    emitSelection() {
        if (this.disabled) {
            return;
        }
        if (this.bus) {
            this.bus.$emit('input', this.value)
        }
    }
}
